export const CONCIERGE_TRACKING_EVENTS = {
  MODAL_OPENED: "concierge_modal_opened",
  MODAL_CLOSED: "concierge_modal_closed",

  NAV_ITEM_CLICKED: "concierge_nav_item_clicked",
  JOIN_MEMBERSHIP_CLICKED: "concierge_join_membership_clicked",
  SEARCH_PAGE_BUTTON_CLICKED: "concierge_search_page_button_clicked",

  REQUEST_SUBMIT_BUTTON_TOUCH: "concierge_request_submit_button_touch",
  // dynamic events:
  // concierge_request_submit_button_touch_dashboard
  // concierge_request_submit_button_touch_membership_purchased_page

  ACCORDION_CLICKED: "concierge_accordion_clicked"
  // dynamic events:
  // concierge_accordion_clicked_dashboard
  // concierge_accordion_clicked_membership_purchased_page
} as const;

export const CONCIERGE_IN_PAGE_SECTION_USAGE = {
  DASHBOARD: "dashboard",
  MEMBERSHIP_PURCHASED_PAGE: "membership_purchased_page"
} as const;

export const CONCIERGE_FEATURE_FLAGS = {
  ENTRY: "concierge-entry"
} as const;

export const CONCIERGE_URL_PARAMS = {
  OPEN_CONCIERGE: "openConcierge"
} as const;

export const CONCIERGE_FROM_EMAIL_URL_PARAMS = {
  EMAIL_SOURCE: "emailSource"
} as const;

export type ConciergeTrackingEvent =
  (typeof CONCIERGE_TRACKING_EVENTS)[keyof typeof CONCIERGE_TRACKING_EVENTS];
export type ConciergeFeatureFlag =
  (typeof CONCIERGE_FEATURE_FLAGS)[keyof typeof CONCIERGE_FEATURE_FLAGS];
export type ConciergeURLParam =
  (typeof CONCIERGE_URL_PARAMS)[keyof typeof CONCIERGE_URL_PARAMS];
